export interface StepContent {
  title: string;
  content: {
    text: string;
    link?: string;
    subSteps?: string[];
    formatting?: {
      bold?: string[];
      underline?: string[];
      italic?: string[];
      underlineItalic?: string[];
      darkBold?: string[];
    };
  }[];
}

// Default onboarding steps (for org_id = 2+)
export const defaultOnboardingSteps: StepContent[] = [
  {
    title: 'Enroll in Pre-Licensing Course',
    content: [
      {
        text: 'The first step to this process is to get enrolled in the Pre-Licensing Course through Xcel Testing Solutions. Below are step-by-step instructions on how to get enrolled. As soon as you get enrolled, CLICK MARK STEP COMPLETE and click NEXT. Keep in mind, you have 72 Hours to enroll in this course, or the opportunity will no longer be available. If for some reason this is not doable, please let me know.',
        formatting: {
          bold: ['CLICK MARK STEP COMPLETE', 'NEXT'],
          darkBold: ['how to get enrolled', '72 Hours']
        }
      },
      {
        text: 'HOW TO GET ENROLLED IN PRE-LICENSING COURSE:',
        formatting: {
          underline: ['HOW TO GET ENROLLED IN PRE-LICENSING COURSE:']
        },
        subSteps: [
          '1. Go to xcelsolutions.com/gl30',
          '2. Click \'insurance\' at the top',
          '3. Click the state you reside in',
          '4. Click \'Enroll Now\' for either the Premier Life course or the Standard Life course',
        ],
      },
      {
        text: 'Discount Codes:',
        subSteps: [
          'Enter discount code "XINS1PP" for $100 off on Premier Package ($200 Total)',
          'Enter discount code "XINS1" for $67 off on Standard Package ($133)',
        ],
        formatting: {
          bold: ['XINS1PP', 'XINS1'],
          underlineItalic: ['Premier Life course', 'Standard Life course']
        }
      },
      {
        text: 'Complete Enrollment:',
        subSteps: [
          '1. Proceed to checkout',
          '2. Sign up for a new student account',
          '3. Enter your Student Account and Contact Information',
        ],
      },
      {
        text: 'Additional Information Section:',
        subSteps: [
          '1. Location: leave blank',
          '2. Branch/Office location: leave blank',
          '3. Hiring Manager: Your Hiring Manager',
          '4. Hiring Manager\'s email: leave blank',
          '5. Proceed to check out and pay',
        ],
      },
    ],
  },
  {
    title: 'Instructions on Passing the Course',
    content: [
      {
        text: 'You have 10 Days to work through the course!',
        formatting: {
          bold: ['10 Days']
        }
      },
      {
        text: 'The goal is to get to the practice test as quickly as possible. Repeat the practice test 10-20 times until you feel confident',
        formatting: {
          bold: ['10-20']
        }
      },
      {
        text: 'Once you have COMPLETED the course, move onto the next step',
        formatting: {
          bold: ['COMPLETED']
        }
      },
    ],
  },
  {
    title: 'Obtain Your Insurance License',
    content: [
      {
        text: '1. Visit prepare2pass.com/requirements',
        link: 'https://prepare2pass.com/requirements',
      },
      {
        text: '2. Select the state you passed your exam in',
      },
      {
        text: '3. Make sure all steps are completed on the PDF document from the website',
      },
    ],
  },
  {
    title: 'Get Appointed with Our Company',
    content: [
      {
        text: 'Complete steps 1-5 in order on our appointment portal',
        link: 'https://sites.google.com/view/ariaspartb/get-started',
      },
    ],
  },
  {
    title: 'Complete Agent Contract',
    content: [
      {
        text: '1. Notify your hiring manager once your state license is approved',
      },
      {
        text: '2. Check your email for "Agent Appointments" from AGENT ADMIN',
      },
      {
        text: '3. Complete the entire form',
      },
      {
        text: '4. Important: Select "YES" for union membership to receive free leads',
      },
    ],
  },
  {
    title: 'Download Zoom',
    content: [
      {
        text: 'Download Zoom from the official website',
        link: 'https://zoom.us/download',
      },
    ],
  },
  {
    title: 'Setup Zoom Pro Account',
    content: [
      {
        text: '1. Watch the setup video',
        link: 'https://youtu.be/wEkYgTyLkYc',
      },
      {
        text: '2. Create your personal meeting ID (recommended: use your phone number)',
        link: 'https://youtu.be/X2x-bqlusik',
      },
      {
        text: '3. Learn how to share your personal meeting ID',
        link: 'https://www.youtube.com/watch?v=SEjtH05WT8g',
      },
    ],
  },
  {
    title: 'Download EAPP',
    content: [
      {
        text: 'Windows Users Link',
        subSteps: [
          'Download EAPP from the provided link',
          'Note: This won\'t work on MAC',
        ],
        link: 'https://thekeefersuccess.com/eAppSetup.msi',
      },
      {
        text: 'MAC Users Link',
        subSteps: [
          'Purchase Parallels (MAC USERS ONLY)',
          'Then download EAPP',
        ],
        link: 'https://parallels.sjv.io/arias',
      },
      {
        text: 'Note: Chromebook users will need to get a new computer',
      },
    ],
  },
  {
    title: 'Create Work Email',
    content: [
      {
        text: 'Setup your work email using this link',
        link: 'https://signup.live.com/signup',
      },
      {
        text: 'Create your email as: firstinitiallastname.ailife@outlook.com',
        subSteps: [
          'Example: Name: John Doe',
          'Email: jdoe.ailife@outlook.com',
        ],
      },
    ],
  },
  {
    title: 'Wait for Agent Number/Code',
    content: [
      {
        text: 'Important Notes:',
        subSteps: [
          'Usually takes about a week to receive',
          'Ensure all steps under Step 2 are completed',
          'Complete the "Agent Appointments" email from Step 3',
          'Verify you have a license number from the state (Step 1)',
        ],
      },
      {
        text: 'If waiting more than a week, text your manager with:',
        subSteps: [
          'Full name',
          'State of residence for license',
          'License number',
        ],
      },
    ],
  },
  {
    title: 'Activate Agent Number/Code',
    content: [
      {
        text: 'Wait 24 hours after receiving the email',
      },
      {
        text: 'Visit the activation website',
        link: 'https://aws.impact.ailife.com/main',
        subSteps: [
          'SAVE YOUR LOGIN INFORMATION (IMPORTANT)',
          'This will be your same login info for EAPP',
        ],
      },
    ],
  },
  {
    title: 'Activate Impact Mobile',
    content: [
      {
        text: 'Look for an email from cdixon@ariasagencies.com',
        subSteps: [
          'Complete setup within 24 hours of receiving the email',
        ],
      },
    ],
  },
  {
    title: 'Apply for Additional Licenses',
    content: [
      {
        text: 'Visit nipr.com and follow these steps:',
        subSteps: [
          '1. Click "apply for a new license"',
          '2. Click "Non-Resident License"',
          '3. Click "Go to Online Application"',
          '4. Click "Individual"',
          '5. Enter your information',
          '6. Click "START"',
          '7. Click "Producer Licensing… Add line of authority… Non-Resident"',
          'Add PA and WV if not already licensed',
        ],
      },
      {
        text: 'Note: NY, TX, CA, MN, MA are not allowed',
      },
    ],
  },
  {
    title: 'Schedule Training',
    content: [
      {
        text: 'Once you have your agent code and everything is set up:',
        subSteps: [
          'Text your trainer to confirm your start date',
          'Read scripts and study in the meantime',
        ],
      },
    ],
  },
];

// Organization-specific onboarding steps (for org_id = 1)
export const org1OnboardingSteps: StepContent[] = [
  {
    title: 'Enroll in Pre-Licensing Course',
    content: [
      {
        text: 'The first step to this process is to get enrolled in the Pre-Licensing Course through Just Insurance. Below are step-by-step instructions on how to get enrolled. As soon as you get enrolled, CLICK MARK STEP COMPLETE and click NEXT. Keep in mind, you have 72 Hours to enroll in this course, or the opportunity will no longer be available. If for some reason this is not doable, please let me know.',
        formatting: {
          bold: ['CLICK MARK STEP COMPLETE', 'NEXT'],
          darkBold: ['how to get enrolled', '72 Hours']
        }
      },
      {
        text: 'HOW TO GET ENROLLED IN PRE-LICENSING COURSE:',
        formatting: {
          underline: ['HOW TO GET ENROLLED IN PRE-LICENSING COURSE:']
        },
        subSteps: [
          '1. Click on this link to enroll in the course: getyourinsurancelicense',
          '2. Afterward purchasing the course, you’ll be directed to an enrollment form. Complete the form and submit it.',
          '3. After submitting the form, you will gain immediate access to your new course—it’s that easy!',
          
        ],
      },
    ],
  },
  {
    title: 'Instructions on Passing the Course',
    content: [
      {
        text: 'You have 10 Days to work through the course!',
        formatting: {
          bold: ['10 Days']
        }
      },
      {
        text: 'The goal is to get to the practice test as quickly as possible. Repeat the practice test 10-20 times until you feel confident',
        formatting: {
          bold: ['10-20']
        }
      },
      {
        text: 'Once you have COMPLETED the course, move onto the next step',
        formatting: {
          bold: ['COMPLETED']
        }
      },
    ],
  },
  {
    title: 'Obtain Your Insurance License',
    content: [
             {
         text: '1. Text 754-223-9744 with your full name and notify them that you have finished the course and are ready for the state test.',
         formatting: {
           bold: ['754-223-9744']
         }
       },
      {
        text: '2. Follow the exact directions they give you to take the test',
      },
      {
        text: '3. After passing the test, reach out that same number and notify them that you passed. They will explain how to get your state license',
      },
    ],
  },
  {
    title: 'Get Appointed with Our Company',
    content: [
      {
        text: 'Complete steps 1-5 in order on our appointment portal',
        link: 'https://sites.google.com/view/ariaspartb/get-started',
      },
    ],
  },
  {
    title: 'Complete Agent Contract',
    content: [
      {
        text: '1. Notify your hiring manager once your state license is approved',
      },
      {
        text: '2. Check your email for "Agent Appointments" from AGENT ADMIN',
      },
      {
        text: '3. Complete the entire form',
      },
      {
        text: '4. Important: Select "YES" for union membership to receive free leads',
      },
    ],
  },
  {
    title: 'Download Zoom',
    content: [
      {
        text: 'Download Zoom from the official website',
        link: 'https://zoom.us/download',
      },
    ],
  },
  {
    title: 'Setup Zoom Pro Account',
    content: [
      {
        text: '1. Watch the setup video',
        link: 'https://youtu.be/wEkYgTyLkYc',
      },
      {
        text: '2. Create your personal meeting ID (recommended: use your phone number)',
        link: 'https://youtu.be/X2x-bqlusik',
      },
      {
        text: '3. Learn how to share your personal meeting ID',
        link: 'https://www.youtube.com/watch?v=SEjtH05WT8g',
      },
    ],
  },
  {
    title: 'Download EAPP',
    content: [
      {
        text: 'Windows Users Link',
        subSteps: [
          'Download EAPP from the provided link',
          'Note: This won\'t work on MAC',
        ],
        link: 'https://thekeefersuccess.com/eAppSetup.msi',
      },
      {
        text: 'MAC Users Link',
        subSteps: [
          'Purchase Parallels (MAC USERS ONLY)',
          'Then download EAPP',
        ],
        link: 'https://parallels.sjv.io/arias',
      },
      {
        text: 'Note: Chromebook users will need to get a new computer',
      },
    ],
  },
  {
    title: 'Create Work Email',
    content: [
      {
        text: 'Setup your work email using this link',
        link: 'https://signup.live.com/signup',
      },
      {
        text: 'Create your email as: firstinitiallastname.ailife@outlook.com',
        subSteps: [
          'Example: Name: Marshall Weinberg',
          'Email: mweinberg.ailife@outlook.com',
        ],
      },
    ],
  },
  {
    title: 'Wait for Agent Number/Code',
    content: [
      {
        text: 'Important Notes:',
        subSteps: [
          'Usually takes about a week to receive - WAIT AT THIS STEP UNTIL RECEIVED',
          'Ensure all steps under Step 4 are completed',
          'Complete the "Agent Appointments" email from Step 5',
          'Verify you have a license number from the state (Step 3)',
        ],
      },
      {
        text: 'If waiting more than a week, text your manager with:',
        subSteps: [
          'Full name',
          'State of residence for license',
          'License number',
        ],
      },
    ],
  },
  {
    title: 'Activate Agent Number/Code',
    content: [
      {
        text: 'Wait 24 hours after receiving the email',
      },
      {
        text: 'Visit the activation website',
        link: 'https://aws.impact.ailife.com/main',
        subSteps: [
          'SAVE YOUR LOGIN INFORMATION (IMPORTANT)',
          'This will be your same login info for EAPP',
        ],
      },
    ],
  },
  {
    title: 'Activate Impact Mobile',
    content: [
      {
        text: 'Look for an email from cdixon@ariasagencies.com',
        subSteps: [
          'Complete setup within 24 hours of receiving the email',
        ],
      },
    ],
  },
  {
    title: 'Apply for Additional Licenses',
    content: [
      {
        text: 'Visit nipr.com and follow these steps:',
        subSteps: [
          '1. Click "apply for a new license"',
          '2. Click "Non-Resident License"',
          '3. Click "Go to Online Application"',
          '4. Click "Individual"',
          '5. Enter your information',
          '6. Click "START"',
          '7. Click "Producer Licensing… Initial… Non-Resident"',
          'Add WV, MD and TN if not already licensed',
        ],
      },
      {
        text: 'Note: NY, TX, CA, MN, MA are not allowed',
      },
    ],
  },
  {
    title: 'Schedule Training',
    content: [
      {
        text: 'Once you have your agent code and everything is set up:',
        subSteps: [
          'Text your trainer to confirm your start date',
          'Read scripts and study in the meantime',
        ],
      },
    ],
  },
];

// Organization-specific onboarding steps (for org_id = 3)
export const org3OnboardingSteps: StepContent[] = [
  {
    title: 'Enroll in Pre-Licensing Course',
    content: [
      {
        text: 'The first step to this process is to get enrolled in the Pre-Licensing Course through Xcel Testing Solutions. Below are step-by-step instructions on how to get enrolled. As soon as you get enrolled, CLICK MARK STEP COMPLETE and click NEXT. Keep in mind, you have 12 Hours to enroll in this course, or the opportunity will no longer be available. If for some reason this is not doable, please let me know.',
        formatting: {
          bold: ['CLICK MARK STEP COMPLETE', 'NEXT'],
          darkBold: ['12 Hours']
        }
      },
      {
        text: 'HOW TO GET ENROLLED IN PRE-LICENSING COURSE:',
        formatting: {
          underline: ['HOW TO GET ENROLLED IN PRE-LICENSING COURSE:']
        },
        subSteps: [
          '1. Go to xcelsolutions.com/ariasevanson',
          "2. Click 'insurance' at the top",
          '3. Click the state you reside in',
          "4. Click 'Enroll Now'  "
        ],
      },
      {
        text: 'Discount Codes:',
        subSteps: [
          'Enter discount code "ARIASEVANSON" for $150 off on Premier Package ($200 Total)'
        ],
        formatting: {
          bold: ['ARIASEVANSON', 'Premier Package']
        }
      },
      {
        text: 'Complete Enrollment:',
        subSteps: [
          '1. Proceed to checkout',
          '2. Sign up for a new student account',
          '3. Enter your Student Account and Contact Information',
        ],
      },
      {
        text: 'Additional Information Section:',
        subSteps: [
          '1. Branch/Office location: leave blank',
          '2. Hiring Manager: Anthony Retone',
          "3. Hiring Manager's email: aretone724@outlook.com",
          '4. Proceed to check out and pay',
        ],
      },
      {
        text: 'Within 24 Hours YOU WILL RECIEVE an EMAIL from ailagentadmin@ailife.com “Welcome to opportunity unlimited”  Fill out and submit the invitation ASAP to lock-in your spot with our company.',
        formatting: {
          bold: ['Within 24 Hours YOU WILL RECIEVE an EMAIL from ailagentadmin@ailife.com “Welcome to opportunity unlimited”  Fill out and submit the invitation ASAP to lock-in your spot with our company.']
        }
      },
      {
        text: 'IF YOU HAVE ANY QUESTIONS TEXT THE GROUP CHAT.'
      }
    ],
  },
  {
    title: 'Instructions on Passing the Course',
    content: [
      {
        text: 'You have 7 Days to work through the course!',
        formatting: {
          bold: ['7 Days']
        }
      },
      {
        text: 'Use QUIZLET to COMPLETE the chapter exams. Skip through all the information (videos and slideshows) until simulated exams',
        formatting: {
          bold: ['QUIZLET', 'COMPLETE']
        }
      },
      {
        text: 'The goal is to get to the simulated exams as QUICKLY as possible. Repeat the simulated exams until you get 95% 5 TIMES.',
        formatting: {
          bold: ['QUICKLY', '95% 5 TIMES']
        }
      },
      {
        text: 'Once you have COMPLETED the course, move onto the next step',
        formatting: {
          bold: ['COMPLETED']
        }
      },
      {
        text: 'Make sure you print out the certificate / you WILL need this on your state exam',
        formatting: {
          bold: ['print out the certificate', 'WILL']
        }
      },
    ],
  },
  {
    title: 'Obtain Your Insurance License',
    content: [
      {
        text: 'Visit prepare2pass.com/requirements',
        link: 'https://prepare2pass.com/requirements',
      },
      {
        text: 'Make sure you schedule your exam within 3-5 days from completing the course.'
      },
      {
        text: 'Select the state you passed your course in'
      },
      {
        text: 'SCHEDULE YOUR FINGERPRINTS APPOINTMENT WITHIN 3 DAYS OF PASSING YOUR TEST. IF YOU NEED TO DRIVE, DRIVE.',
        formatting: {
          bold: ['SCHEDULE YOUR FINGERPRINTS APPOINTMENT WITHIN 3 DAYS OF PASSING YOUR TEST. IF YOU NEED TO DRIVE, DRIVE.']
        }
      },
      {
        text: 'Make sure all steps are completed on the PDF document from the website'
      },
    ],
  },
  {
    title: 'Get Appointed with Our Company',
    content: [
      {
        text: 'Complete steps 1-5 in order on our appointment portal',
        link: 'https://sites.google.com/view/ariaspartb/get-started',
      },
    ],
  },
  {
    title: 'Download Zoom',
    content: [
      {
        text: 'Download Zoom from the official website',
        link: 'https://zoom.us/download',
      },
    ],
  },
  {
    title: 'Setup Zoom Pro Account',
    content: [
      {
        text: '1. Watch the setup video',
        link: 'https://youtu.be/wEkYgTyLkYc',
      },
      {
        text: '2. Create your personal meeting ID (recommended: use your phone number)',
        link: 'https://youtu.be/X2x-bqlusik',
      },
      {
        text: '3. Learn how to share your personal meeting ID',
        link: 'https://www.youtube.com/watch?v=SEjtH05WT8g',
      },
    ],
  },
  {
    title: 'Download EAPP',
    content: [
      {
        text: 'Windows Users Link',
        subSteps: [
          'Download EAPP from the provided link',
          "Note: This won't work on MAC",
        ],
         link: 'https://thekeefersuccess.com/eAppSetup.msi'
      },
      {
        text: 'MAC Users Link',
        subSteps: [
          'Purchase Parallels (MAC USERS ONLY)',
          'Then download EAPP',
        ],
        link: 'https://parallels.sjv.io/arias',
      },
      {
        text: 'Note: Chromebook users will need to get a new computer',
      },
    ],
  },
  {
    title: 'Create Work Email',
    content: [
      {
        text: 'Setup your work email using this link',
        link: 'https://signup.live.com/signup',
      },
      {
        text: 'Create your email as: firstinitiallastname.ailife@outlook.com',
        subSteps: [
          'Example: Name: Anthony Retone',
          'Email: aretone.ailife@outlook.com',
        ],
      },
    ],
  },
  {
    title: 'Wait for Agent Number/Code',
    content: [
      {
        text: 'Important Notes:',
        subSteps: [
          'Usually takes about a week to receive',
          'Ensure all steps under Step 2 are completed',
          'Complete the "Agent Appointments" email from Step 1',
          'Verify you have a license number from the state (Step 3)',
        ],
      },
      {
        text: 'If waiting more than a week, text your manager with:',
        subSteps: [
          'Full name',
          'State of residence for license',
          'License number',
        ],
      },
    ],
  },
  {
    title: 'Activate Agent Number/Code',
    content: [
      {
        text: 'Wait 24 hours after receiving the email',
      },
      {
        text: 'Visit the activation website',
        link: 'https://aws.impact.ailife.com/main',
      },
      {
        text: 'MAKE YOUR LOGIN INFORMATION (IMPORTANT)',
        formatting: {
          bold: ['MAKE YOUR LOGIN INFORMATION (IMPORTANT)']
        }
      },
      {
        text: 'Make your EAPP username as SIMILAR as possible to the example below',
        subSteps: [
          'EXAMPLE:',
          'Make your EAPP Password 12345678',
          'Fullname: Anthony Retone',
          'Username: aretone',
          'Password: 12345678',
          'This will be your same login info for EAPP',
        ],
      },
      {
        text: 'Send your EAPP login username and password INTO THE GROUP CHAT with Manager once its created.'
      },
    ],
  },
  {
    title: 'Activate Impact Mobile',
    content: [
      {
        text: 'Look for an email from cdixon@ariasagencies.com',
        subSteps: [
          'Complete setup within 24 hours of receiving the email',
        ],
      },
    ],
  },
  {
    title: 'Apply for Additional Licenses',
    content: [
      {
        text: 'Visit nipr.com and follow these steps:',
        link: 'https://nipr.com',
        subSteps: [
          '1. Click "apply for a new license"',
          '2. Click "Non-Resident License"',
          '3. Click "Go to Online Application"',
          '4. Click "Individual"',
          '5. Enter your information',
          '6. Click "START"',
          '7. Click "Producer Licensing… Initial… Non-Resident"',
          'Add PA and WV if not already licensed',
        ],
      },
      {
        text: 'Note: NY, TX, CA, MN, MA are not allowed',
      },
    ],
  },
  {
    title: 'Download this zip file',
    content: [
      {
        text: '1. Download this zip file and memorize it word for word.',
      },
      {
        text: '2. MILLION DOLLAR PLAN.zip',
        link: 'https://angels-bucket-1351351.s3.us-east-1.amazonaws.com/MILLION_DOLLAR_PLAN.zip',
      },
      
    ],
  },
  {
    title: 'Download Discord',
    content: [
      {
        text: '1. Find the welcome tab',
      },
      {
        text: '2. Join 330Familia',
        link: 'https://discord.gg/2gBF5X58',
      },
    ],
  },
];

export const org2OnboardingSteps: StepContent[] = [
  {
    title: 'Enroll in Pre-Licensing Course',
    content: [
      {
        text: 'The first step to this process is to get enrolled in the Pre-Licensing Course through Xcel Testing Solutions. Below are step-by-step instructions on how to get enrolled. As soon as you get enrolled, CLICK MARK STEP COMPLETE and click NEXT. Keep in mind, you have 12 Hours to enroll in this course, or the opportunity will no longer be available. If for some reason this is not doable, please let me know.',
        formatting: {
          bold: ['CLICK MARK STEP COMPLETE', 'NEXT'],
          darkBold: ['12 Hours']
        }
      },
      {
        text: 'HOW TO GET ENROLLED IN PRE-LICENSING COURSE:',
        formatting: {
          underline: ['HOW TO GET ENROLLED IN PRE-LICENSING COURSE:']
        },
        subSteps: [
          '1. Go to xcelsolutions.com/ariasevanson',
          "2. Click 'insurance' at the top",
          '3. Click the state you reside in',
          "4. Click 'Enroll Now'  "
        ],
      },
      {
        text: 'Discount Codes:',
        subSteps: [
          'Enter discount code "ARIASEVANSON" for $150 off on Premier Package ($200 Total)'
        ],
        formatting: {
          bold: ['ARIASEVANSON', 'Premier Package']
        }
      },
      {
        text: 'Complete Enrollment:',
        subSteps: [
          '1. Proceed to checkout',
          '2. Sign up for a new student account',
          '3. Enter your Student Account and Contact Information',
        ],
      },
      {
        text: 'Additional Information Section:',
        subSteps: [
          '1. Branch/Office location: leave blank',
          '2. Hiring Manager: Angel Perez',
          "3. Hiring Manager's email: aperez@ariasagencies.com",
          '4. Proceed to check out and pay',
        ],
      },
      {
        text: 'Within 24 Hours YOU WILL RECIEVE an EMAIL from ailagentadmin@ailife.com “Welcome to opportunity unlimited”  Fill out and submit the invitation ASAP to lock-in your spot with our company.',
        formatting: {
          bold: ['Within 24 Hours YOU WILL RECIEVE an EMAIL from ailagentadmin@ailife.com “Welcome to opportunity unlimited”  Fill out and submit the invitation ASAP to lock-in your spot with our company.']
        }
      },
      {
        text: 'IF YOU HAVE ANY QUESTIONS TEXT THE GROUP CHAT.'
      }
    ],
  },
  {
    title: 'Instructions on Passing the Course',
    content: [
      {
        text: 'You have 7 Days to work through the course!',
        formatting: {
          bold: ['7 Days']
        }
      },
      {
        text: 'Use QUIZLET to COMPLETE the chapter exams. Skip through all the information (videos and slideshows) until simulated exams',
        formatting: {
          bold: ['QUIZLET', 'COMPLETE']
        }
      },
      {
        text: 'The goal is to get to the simulated exams as QUICKLY as possible. Repeat the simulated exams until you get 95% 5 TIMES.',
        formatting: {
          bold: ['QUICKLY', '95% 5 TIMES']
        }
      },
      {
        text: 'Once you have COMPLETED the course, move onto the next step',
        formatting: {
          bold: ['COMPLETED']
        }
      },
      {
        text: 'Make sure you print out the certificate / you WILL need this on your state exam',
        formatting: {
          bold: ['print out the certificate', 'WILL']
        }
      },
    ],
  },
  {
    title: 'Obtain Your Insurance License',
    content: [
      {
        text: 'Visit prepare2pass.com/requirements',
        link: 'https://prepare2pass.com/requirements',
      },
      {
        text: 'Make sure you schedule your exam within 3-5 days from completing the course.'
      },
      {
        text: 'Select the state you passed your course in'
      },
      {
        text: 'SCHEDULE YOUR FINGERPRINTS APPOINTMENT WITHIN 3 DAYS OF PASSING YOUR TEST. IF YOU NEED TO DRIVE, DRIVE.',
        formatting: {
          bold: ['SCHEDULE YOUR FINGERPRINTS APPOINTMENT WITHIN 3 DAYS OF PASSING YOUR TEST. IF YOU NEED TO DRIVE, DRIVE.']
        }
      },
      {
        text: 'Make sure all steps are completed on the PDF document from the website'
      },
    ],
  },
  {
    title: 'Get Appointed with Our Company',
    content: [
      {
        text: 'Complete steps 1-5 in order on our appointment portal',
        link: 'https://sites.google.com/view/ariaspartb/get-started',
      },
    ],
  },
  {
    title: 'Download Zoom',
    content: [
      {
        text: 'Download Zoom from the official website',
        link: 'https://zoom.us/download',
      },
    ],
  },
  {
    title: 'Setup Zoom Pro Account',
    content: [
      {
        text: '1. Watch the setup video',
        link: 'https://youtu.be/wEkYgTyLkYc',
      },
      {
        text: '2. Create your personal meeting ID (recommended: use your phone number)',
        link: 'https://youtu.be/X2x-bqlusik',
      },
      {
        text: '3. Learn how to share your personal meeting ID',
        link: 'https://www.youtube.com/watch?v=SEjtH05WT8g',
      },
    ],
  },
  {
    title: 'Download EAPP',
    content: [
      {
        text: 'Windows Users Link',
        subSteps: [
          'Download EAPP from the provided link',
          "Note: This won't work on MAC",
        ],
         link: 'https://thekeefersuccess.com/eAppSetup.msi'
      },
      {
        text: 'MAC Users Link',
        subSteps: [
          'Purchase Parallels (MAC USERS ONLY)',
          'Then download EAPP',
        ],
        link: 'https://parallels.sjv.io/arias',
      },
      {
        text: 'Note: Chromebook users will need to get a new computer',
      },
    ],
  },
  {
    title: 'Create Work Email',
    content: [
      {
        text: 'Setup your work email using this link',
        link: 'https://signup.live.com/signup',
      },
      {
        text: 'Create your email as: firstinitiallastname.ailife@outlook.com',
        subSteps: [
          'Example: Name: Angel Perez',
          'Email: aperez.ailife@outlook.com',
        ],
      },
    ],
  },
  {
    title: 'Wait for Agent Number/Code',
    content: [
      {
        text: 'Important Notes:',
        subSteps: [
          'Usually takes about a week to receive',
          'Ensure all steps under Step 2 are completed',
          'Complete the "Agent Appointments" email from Step 1',
          'Verify you have a license number from the state (Step 3)',
        ],
      },
      {
        text: 'If waiting more than a week, text your manager with:',
        subSteps: [
          'Full name',
          'State of residence for license',
          'License number',
        ],
      },
    ],
  },
  {
    title: 'Activate Agent Number/Code',
    content: [
      {
        text: 'Wait 24 hours after receiving the email',
      },
      {
        text: 'Visit the activation website',
        link: 'https://aws.impact.ailife.com/main',
      },
      {
        text: 'MAKE YOUR LOGIN INFORMATION (IMPORTANT)',
        formatting: {
          bold: ['MAKE YOUR LOGIN INFORMATION (IMPORTANT)']
        }
      },
      {
        text: 'Make your EAPP username as SIMILAR as possible to the example below',
        subSteps: [
          'EXAMPLE:',
          'Make your EAPP Password 12345678',
          'Fullname: Angel Perez',
          'Username: aperez',
          'Password: 12345678',
          'This will be your same login info for EAPP',
        ],
      },
      {
        text: 'Send your EAPP login username and password INTO THE GROUP CHAT with Manager once its created.'
      },
    ],
  },
  {
    title: 'Activate Impact Mobile',
    content: [
      {
        text: 'Look for an email from cdixon@ariasagencies.com',
        subSteps: [
          'Complete setup within 24 hours of receiving the email',
        ],
      },
    ],
  },
  {
    title: 'Apply for Additional Licenses',
    content: [
      {
        text: 'Visit nipr.com and follow these steps:',
        link: 'https://nipr.com',
        subSteps: [
          '1. Click "apply for a new license"',
          '2. Click "Non-Resident License"',
          '3. Click "Go to Online Application"',
          '4. Click "Individual"',
          '5. Enter your information',
          '6. Click "START"',
          '7. Click "Producer Licensing… Initial… Non-Resident"',
          'Add PA and WV if not already licensed',
        ],
      },
      {
        text: 'Note: NY, TX, CA, MN, MA are not allowed',
      },
    ],
  },
  {
    title: 'Download this zip file',
    content: [
      {
        text: '1. Download this zip file and memorize it word for word.',
      },
      {
        text: '2. MILLION DOLLAR PLAN.zip',
        link: 'https://angels-bucket-1351351.s3.us-east-1.amazonaws.com/MILLION_DOLLAR_PLAN.zip',
      },
      
    ],
  },
  {
    title: 'Signup for Calendly',
    content: [
      {
        text: 'Sign up here',
        link: 'https://calendly.com/signup',
      },
    ],
  },
];

// Function to get onboarding steps based on organization ID
export const getOnboardingSteps = (orgId: number): StepContent[] => {
  switch (orgId) {
    case 1:
      return org1OnboardingSteps;
    case 2:
      return org2OnboardingSteps;
    case 3:
      return org3OnboardingSteps;
    default:
      return defaultOnboardingSteps;
  }
};

// Legacy export for backward compatibility
export const onboardingSteps = defaultOnboardingSteps; 